var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#fff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2330 5110 c-494 -48 -950 -230 -1350 -538 -195 -150 -448 -432 -594 -662 -63 -99 -186 -351 -230 -471 -49 -134 -102 -340 -128 -499 -31 -195 -31 -565 0 -760 45 -276 116 -498 237 -745 132 -269 269 -460 489 -681 221 -220 412 -357 681 -489 247 -121 469 -192 745 -237 195 -31 565 -31 760 0 276 45 498 116 745 237 269 132 460 269 681 489 220 221 357 412 489 681 123 250 194 477 237 750 31 200 31 550 0 750 -43 273 -114 500 -237 750 -132 269 -269 460 -489 681 -221 220 -412 357 -681 489 -246 121 -474 193 -740 235 -147 23 -475 34 -615 20z m430 -351 c872 -79 1622 -675 1896 -1506 350 -1060 -145 -2212 -1156 -2691 -1014 -481 -2227 -116 -2825 848 -531 858 -396 1990 325 2710 465 465 1108 699 1760 639z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2435 4089 c-36 -10 -79 -48 -102 -92 -17 -30 -18 -87 -18 -817 0 -432 3 -797 7 -812 10 -35 53 -85 92 -106 28 -15 92 -17 726 -20 382 -2 718 0 747 3 172 21 226 217 89 319 -27 21 -41 21 -669 26 l-642 5 -5 695 c-4 500 -8 701 -17 715 -18 32 -55 63 -95 80 -41 17 -68 18 -113 4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.da9dfe1b86d3592d1d8b2c1bdb85dd05.svg";
export { ForwardRef as ReactComponent };